<script setup lang="ts">
defineProps<{ expanded?: boolean }>()
</script>

<template>
  <span class="individual-sale-icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="8" r="3" />
      <path d="M6 20v-2a6 6 0 0 1 12 0v2" />
      <path v-if="expanded" d="M18 5h4M20 3v4" />
    </svg>
  </span>
</template>

<style scoped>
.individual-sale-icon {
  display: inline-flex;
  flex: none;
  width: 1.5rem;
  height: 1.5rem;
  border: 2px solid var(--tq-info-readable);
  border-radius: 50%;
  background: var(--tq-bg-elevated);
  color: var(--tq-info-readable);
  box-shadow: var(--tq-shadow-tight);
}
.individual-sale-icon svg { width: 100%; height: 100%; }
</style>
